<template>
    <div>
        <el-button type="primary" size="mini" @click="add">添加机器人</el-button>
        <el-dialog
            title="添加机器人"
            :visible.sync="showdialog"
            width="1200px">
            <div class="base-warp">
                <div class="head">
                    <el-form label-width="80px" :inline="false" size="mini">
                        <el-form-item label="选择文件">
                            <div class="flex-box">
                                <el-upload
                                    class="upload-demo"
                                    accept=".xls,.xlsx"
                                    action=""
                                    ref="upload"
                                    :limit="5"
                                    :on-change="upload"
                                    :auto-upload="false"
                                    :show-file-list="false">
                                    <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
                                </el-upload>
                                <el-button class="save-btn" type="success" size="mini" @click="save">保存机器人</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table :data="robots" border stripe>
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="index" label="头像" width="80" align="center">
                            <template slot-scope="s">
                                <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover">
                                    <el-image class="ltpic" :src="s.row.ltpic" fit="scale-down"></el-image>
                                    <el-avatar class="avatar" slot="reference" icon="el-icon-user-solid" size="large" shape="circle" :src="s.row.ltpic" fit="fill"></el-avatar>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column label="操作" width="80" align="center">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="delrow(s.$index)" plain>删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            
        </el-dialog>
        
    </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
    name: 'RobotAdd',
    data() {
        return {
            showdialog: false,
            robots: [],
        }
    },
    methods: {
        delrow(index) {
            console.log(index)
            this.robots.splice(index, 1);
        },
        save() {
            var params  ={
                infos: JSON.stringify(this.robots)
            }
            this.$api.addRobot(params).then(
                data=>{
                    this.$Message.success('添加机器人成功');
                }
            )
        },
        upload(file,fileList){
            let files = {0:file.raw}
            this.readExcel1(files);
        },
        add() {
            this.showdialog = true;
        },
        
        formateData(ws) {
            if (typeof ws !='object'){
                this.$Message.success('数据类型错误')
                return;
            }

            var robots = [];
            for (var user of ws){
                var pic = this.getPics();
                var obj  ={
                    name: user['隔夜面包'],
                    ltpic: 'https://api.hangehouse.com/ltpic/'+pic+'.jpg',
                }
                robots.push(obj)
            }
            this.robots = robots;
        },
        readExcel1(files) {//表格导入
            var that = this;
            // console.log(files);
            if(files.length<=0){//如果没有文件名
                return false;
            }else if(!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())){
                this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
                return false;
            }
    
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, {
                        type: 'binary'
                    });
                    const wsname = workbook.SheetNames[0];//取第一张表
                    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
                    // console.log(ws);
                    this.formateData(ws);

                    try{
                        
                    }catch(err){
                        console.log(err)
                    }
                    this.$refs.upload.value = '';
                } catch (e) {
                    return false;
                }
            };
            fileReader.readAsBinaryString(files[0]);
        },
        getPics() {
            var pic = '';
            var types = this.random(1, 4);
            if (types==1){
                var str = this.random(1, 2437);
                return pic = str*3;
            } else if (types == 2){
                var str = this.random(1, 1970);
                return pic = 'a'+str;
            } else if (types == 3){
                var str = this.random(1, 1365);
                return pic = 'b'+str;
            } else if (types == 4){
                var str = this.random(1, 778);
                return pic = 'z'+str+'a'+str;
            }
        },
        random(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.save-btn{
    margin-left: 20px;
}
</style>